import React from 'react'

const GeneralParsing = () => {
  return (
    <div>GeneralParsing</div>
  )
}

export default GeneralParsing